// src/components/auth/ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import WelcomeHeader from '../layout/WelcomeHeader';
import styles from './Login.module.css';
import { authApi } from '../../api';

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent' | 'error'
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('sending');
    const result = await authApi.forgotPassword(email.trim());
    // Backend-Antwort ist immer generisch erfolgreich (kein User-Enumeration möglich)
    setStatus(result.success ? 'sent' : 'error');
  };

  return (
    <>
      <WelcomeHeader />
      <div className={styles.authContainer}>
        <div className={styles.authCard}>
          <div className={styles.authLogo}>
            <img src={require('../../assets/logo_1.png')} alt="MangaShelf" className={styles.authLogoImg} />
          </div>

          <div className={styles.authHeader}>
            <h1 className={styles.authTitle}>{t('forgotPassword.title')}</h1>
            <p className={styles.authSubtitle}>
              {t('forgotPassword.subtitle')}
            </p>
          </div>

          {status === 'sent' ? (
            <div className={styles.authActions}>
              <p className={styles.authSubtitle}>
                {t('forgotPassword.sentText')}
              </p>
              <button onClick={() => navigate('/login')} className={styles.linkButton}>
                {t('forgotPassword.backToLogin')}
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className={styles.authForm}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>{t('forgotPassword.emailLabel')}</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={styles.formInput}
                  placeholder={t('forgotPassword.emailPlaceholder')}
                  autoComplete="email"
                />
              </div>

              {status === 'error' && (
                <div className={styles.errorMessage}>
                  {t('forgotPassword.sendError')}
                </div>
              )}

              <button type="submit" className={styles.submitButton} disabled={status === 'sending'}>
                {status === 'sending' ? t('forgotPassword.sending') : t('forgotPassword.sendLink')}
              </button>
            </form>
          )}

          <div className={styles.divider}>
            <span>{t('auth.or')}</span>
          </div>

          <div className={styles.authActions}>
            <button onClick={() => navigate('/login')} className={styles.backButton}>
              ← {t('forgotPassword.backToLogin')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
